import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import {
    Box,
    Button,
    Container,
    Paper,
    Snackbar,
    Stack,
    Typography,
} from '@mui/material';

import ColorPicker from '../../components/common/color-picker';
import EditProfile from '../more/edit-profile';
import { useAuth } from '../../hooks';
import { ACCOUNT_TYPES } from '../../constants';
import { updateUser } from '../../clients/profile';


const DEFAULT_COVER_COLOR = '#F67F7F';
const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';

interface ProfileSettingsProps {

}

export default function ProfileSettings({}: ProfileSettingsProps) {
    const dispatcher = useDispatch();
    const navigate = useNavigate();

    const { user, token } = useAuth();
    
    const [coverColor, setCoverColor] = useState(user.profile.page_settings?.cover_color || DEFAULT_COVER_COLOR);
    const [backgroundColor, setBackgroundColor] = useState(user.profile.page_settings?.background_color || DEFAULT_BACKGROUND_COLOR);
    const [saved, setSaved] = useState(false);

    const saveChanges = async () => {
        const pageSettingsCopy = user.profile.page_settings || {};

        const success = await updateUser(dispatcher, navigate, user, token, {
            page_settings: {
                ...pageSettingsCopy,
                cover_color: coverColor,
                background_color: backgroundColor,
            },
        });

        if (success) {
            setSaved(true);
        }
    };

    return (
        <Container maxWidth="lg">
            <EditProfile />
            {user.profile.profile_type === ACCOUNT_TYPES.EXPERT && (
                <Box mt={2}>
                    <Paper elevation={0}>
                        <Box p={4}>
                            <Typography variant="h6">Customize Profile</Typography>
                            <Stack spacing={2} mt={2}>
                                <Typography variant="subtitle1">Choose a cover color:</Typography>
                                <ColorPicker selectedColor={coverColor} setSelectedColor={setCoverColor} />
                                <Typography variant="subtitle1">Choose a background color:</Typography>
                                <ColorPicker selectedColor={backgroundColor} setSelectedColor={setBackgroundColor} />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={saveChanges}
                                >
                                    Save
                                </Button>
                            </Stack>
                        </Box>
                    </Paper>
                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        open={saved}
                        autoHideDuration={3000}
                        onClose={() => setSaved(false)}
                        message="Your customizations have been saved!"
                    />
                </Box>
            )}
        </Container>
    );
}
